<div class="indicator-content">
  <div class="indicator-header">
    <span class="indicator-title"> <b>Top 10:</b> CRMs mais utilizados </span>
    <div fxLayoutAlign="end center">
      <indicator-filter (filterDataEvent)="onFilterData($event)"></indicator-filter>
    </div>
  </div>
  <div *ngIf="isLoading" class="loader-container">
    <indicator-loader></indicator-loader>
  </div>
  <div *ngIf="!isLoading" class="indicator-content-container">
    <div class="indicator-total">Total: {{ getTotal() }}</div>
    <div class="table-grid table-header">
      <span>Nome</span>
      <span class="center-column">CRM</span>
      <span class="center-column">Vendas</span>
      <span class="grid-rank">Ranking(%)</span>
    </div>
    <div *ngFor="let practitioner of getTopTenPractitionerList(); trackBy: trackByFn" class="table-grid table-body">
      <!-- column 1 -->
      <div class="column-1">
        <img src="./assets/icons/practitioner-icon 2.svg" />
        <span [matTooltip]="practitioner.practitionerName">{{ practitioner.practitionerName }}</span>
      </div>
      <!-- column 2 -->
      <div class="column-2">
        <span>{{ practitioner.practitionerRegistration }} - {{ practitioner.practitionerState }}</span>
      </div>
      <!-- column 3 -->
      <div class="column-2">
        <span>{{ practitioner.practitionerQuantity }}</span>
      </div>
      <!-- column 5 -->
      <div class="column-4">
        <div class="progressive-bar" [style.width.%]="practitioner.practitionerPercentage"></div>
        <span>{{ practitioner.practitionerPercentage }}%</span>
      </div>
    </div>
    <div *ngIf="!hasTopTenPractitionerData()" class="no-results">
      <p>Não foram encontrados resultados.</p>
    </div>
  </div>
</div>
